/** Her Canavar Çek basışında arkaplanın sola kayma miktarı (px) */
export const BATTLE_BG_SCROLL_PX = 10;

/** Arkaplan kaydırma animasyon süresi (ms) */
export const BATTLE_BG_SCROLL_DURATION_MS = 700;

/** Harita sonuna gelince başa sarma süresi (ms) */
export const BATTLE_BG_REWIND_DURATION_MS = 400;

/** Kaynak PNG boyutları (2100×300) — max kaydırma hesabı için */
export const BATTLE_BG_NATIVE_WIDTH = 2100;
export const BATTLE_BG_NATIVE_HEIGHT = 300;

/** Canavar saldırırken karakterden geri durma mesafesi (px) */
export const MONSTER_ATTACK_STANDOFF_PX = 20;

/** Metin taşı düşüş / duruş konumu — karakter merkezine göre sağa kayma (px) */
export const METIN_FEET_OFFSET_X = 78;
